import styles from './creativePolicy.module.scss';

export const CreativePolicy: React.FC = () => {
  return (
    <div className={styles.creativePolicy}>
      <section>
        <h2 className={styles.sectionTitle}>一、基本規範</h2>
        <ul>
          <li>系統會自動在素材上加注「AD」標示，<b>製稿時請勿自行加上「AD」字樣</b>。</li>
          <li>素材需<b>包含明確的 Call To Action（CTA）</b>按鈕或線框引導，例如：<br/>
          「新品上市・限時搶」「 11/11 限定」「獨家機型開賣」「現正熱賣中」 等。</li>
          <li>版面編排需清楚可讀；<b>排版不佳將退件。</b>如有疑慮，請於 <b>LINE OA 索取 PSD 模板</b>。</li>
        </ul>
      </section>
      <section>
        <h2 className={styles.sectionTitle}>二、提交流程與時程</h2>
        <ul>
          <li><b>請於預計曝光日前 5 天</b>完成上稿並送審，以利排程與稽核。</li>
        </ul>
      </section>
      <section>
        <h2 className={styles.sectionTitle}>三、常見退件原因</h2>
        <div>
          <h3 className={styles.subSectionTitle}>圖片／排版</h3>
          <ul>
            <li>圖片解析度過低，或未依平台尺寸規格（請參考 PSD 模板）。</li>
            <li>產品圖不清楚、裁切不當或重點不明。</li>
            <li>排版雜亂、文字與圖像擠壓，影響辨識。</li>
          </ul>
        </div>
        <div>
          <h3 className={styles.subSectionTitle}>品牌／授權</h3>
          <ul>
            <li>使用<b>未經授權</b>之第三方平台 LOGO（如：PChome LOGO）。</li>
            <li>使用<b>非自家品牌 LOGO 或商品</b>（須附授權聲明；未提供不得投放）。</li>
            <li>品牌 LOGO 占比<b>超過版面面積 20%</b>。</li>
            <li>如涉及第三方肖像／商標／版權，請<b>隨稿附上正式授權文件</b>，以免延誤審核。</li>
          </ul>
        </div>
        <div>
          <h3 className={styles.subSectionTitle}>內容／用語</h3>
          <ul>
            <li>素材內容與產品不相關，或有誤導之嫌。</li>
            <li>使用 before/after 比較圖。</li>
            <li>使用煽動性、無根據、誇大或具誤導性的文字或元素，例如：「最有效」「唯一」「保證」等缺乏客觀證明之描述。</li>
          </ul>
        </div>
        <div>
          <h3 className={styles.subSectionTitle}>法規</h3>
          <ul>
            <li>使用處方藥物或受法律管制之商品。</li>
            <li>觸及法規明定不得廣告或促銷之品項（如：嬰兒配方食品）或療效宣稱文字。</li>
          </ul>
        </div>
      </section>
      <section>
        <h2 className={styles.sectionTitle}>四、嚴禁事項</h2>
        <ul>
          <li><b>未經合法授權</b>之個人（明星、政治人物、KOC/KOL）、團體、公司等圖像<br/>
          （須附可檢附之授權聲明；未提供不得投放）。</li>
          <li>與平台其他政策衝突、或<b>可能引起一般消費者不適</b>之內容。</li>
          <li><b>政治／選舉／社會敏感議題</b>之元素或文字。</li>
          <li><b>違反法律或善良風俗</b>之元素或文字：含（但不限於）色情、暴力、賭博、詐騙。</li>
          <li><b>歧視性表述：</b>涉及性別、種族、膚色、宗教信仰、身心障礙等。</li>
        </ul>
      </section>
    </div>
  );
};
